export const budgetCategories=[['maintenance','Manutenção e revisões'],['insurance','Seguro'],['tyres','Pneus'],['tax_inspection','IUC e inspeção'],['other','Outros custos']] as const;
export function budgetPreview(plan:any){
 const base=plan?.monthly_base_cents??null;
 const lines=budgetCategories.map(([key,label])=>{const rule=plan?.[key];return {key,label,cents:!rule||rule.mode==='pending'?null:rule.mode==='fixed'?rule.cents:base===null||rule.basis_points==null?null:Math.round(base*rule.basis_points/10000)};});
 return {lines,subtotal_cents:lines.reduce((sum,l)=>sum+(l.cents??0),0),complete:lines.every(l=>l.cents!==null)};
}
